"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7101],{

/***/ 761203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ LoginUserIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var LoginUserIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16",
        height: props.height || "18.963",
        viewBox: "0 0 24.02 24.49",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "user-10",
            transform: "translate(-23.819 -26.9)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_132898",
                    "data-name": "Path 132898",
                    d: "M54.666,33.833a6.833,6.833,0,1,0-6.833,6.833A6.834,6.834,0,0,0,54.666,33.833Zm-11.883,0a5.05,5.05,0,1,1,5.05,5.05A5.046,5.046,0,0,1,42.782,33.833Z",
                    transform: "translate(-12.005)",
                    stroke: "#000",
                    strokeWidth: "0.2",
                    fill: props.color
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_132899",
                    "data-name": "Path 132899",
                    d: "M24.39,89.081a.838.838,0,0,0,.446.119.861.861,0,0,0,.772-.446,11.756,11.756,0,0,1,20.469,0,.892.892,0,0,0,1.545-.891,13.566,13.566,0,0,0-23.588,0A.893.893,0,0,0,24.39,89.081Z",
                    transform: "translate(0 -37.958)",
                    stroke: "#000",
                    strokeWidth: "0.2",
                    fill: props.color
                })
            ]
        })
    });
};


/***/ }),

/***/ 644992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ShoppingBag; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var ShoppingBag = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16",
        height: props.height || "18.963",
        viewBox: "0 0 16 18.963",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            id: "shopping-bag-6",
            transform: "translate(-40)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                id: "Path_132897",
                "data-name": "Path 132897",
                d: "M55.259,4.444H53a5.037,5.037,0,0,0-10,0H40.741A.741.741,0,0,0,40,5.185V18.222a.741.741,0,0,0,.741.741H55.259A.741.741,0,0,0,56,18.222V5.185A.741.741,0,0,0,55.259,4.444ZM48,1.481a3.561,3.561,0,0,1,3.506,2.963H44.494A3.561,3.561,0,0,1,48,1.481Zm6.519,16H41.481V5.926H54.519Z",
                fill: props.color
            })
        })
    });
};


/***/ }),

/***/ 247101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Headers_Header11; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/redux/actions/additionalPages.js
var additionalPages = __webpack_require__(792516);
// EXTERNAL MODULE: ./src/redux/actions/storeInfo.js
var storeInfo = __webpack_require__(117321);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/Common/ReactHamburger/index.js + 1 modules
var ReactHamburger = __webpack_require__(70440);
// EXTERNAL MODULE: ./src/components/LoginAndDropdownComponent/index.js
var LoginAndDropdownComponent = __webpack_require__(629492);
// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/utils/getContrastingColor.js
var getContrastingColor = __webpack_require__(833104);
// EXTERNAL MODULE: ./src/utils/invertAngleRightIconColor.js
var invertAngleRightIconColor = __webpack_require__(636874);
// EXTERNAL MODULE: ./src/utils/showMegaMenu.js
var showMegaMenu = __webpack_require__(36408);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/components/DesignSystem/Headers/CommonHeaderIcons/index.js + 2 modules
var CommonHeaderIcons = __webpack_require__(335022);
// EXTERNAL MODULE: ./src/assets/svgExports/ShoppingBag.js
var ShoppingBag = __webpack_require__(644992);
// EXTERNAL MODULE: ./src/assets/svgExports/LoginUserIcon.js
var LoginUserIcon = __webpack_require__(761203);
// EXTERNAL MODULE: ./src/assets/svgExports/HeaderInfoIcon.js
var HeaderInfoIcon = __webpack_require__(337247);
// EXTERNAL MODULE: ./src/assets/svgExports/HeaderHome.js
var HeaderHome = __webpack_require__(452882);
// EXTERNAL MODULE: ./src/components/DesignSystem/Headers/StoreNameComponent/index.js
var StoreNameComponent = __webpack_require__(644128);
// EXTERNAL MODULE: ./src/components/DesignSystem/Headers/ShopComponent/index.js + 1 modules
var ShopComponent = __webpack_require__(811525);
// EXTERNAL MODULE: ./src/assets/svgExports/SearchIcon.js
var SearchIcon = __webpack_require__(350127);
// EXTERNAL MODULE: ./src/components/DesignSystem/Headers/CommonNavbarText/CommonNavbarText.js
var CommonNavbarText = __webpack_require__(932461);
// EXTERNAL MODULE: ./src/hooks/useSaveHeaderHeight.js
var useSaveHeaderHeight = __webpack_require__(953395);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/redux/reducers/index.ts + 19 modules
var reducers = __webpack_require__(950682);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/getNavList.js
var getNavList = __webpack_require__(704956);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/HeaderUtils/headerNavigationUtils.ts


var getNavigationListFiltered = function(navigationList) {
    var visibleItemsLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* MAX_VISIBLE_NAV_LINKS */.Ow;
    return (0,getNavList/* default */.ZP)(navigationList, visibleItemsLength);
};

;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/HeaderUtils/useHeaderData.ts



var useHeaderData = function(headerProps) {
    var ref, ref1;
    var ref2 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList,
            collections: state.catalogReducer.collections
        };
    }), storeData = ref2.storeData, navigationList = ref2.navigationList, collections = ref2.collections;
    var navItems = getNavigationListFiltered(navigationList);
    var ref3 = (0,reducers/* useSelector */.v)(function(state) {
        return {
            items: state.cartReducer.items,
            user: state.userReducer
        };
    }), items = ref3.items, user = ref3.user;
    var headerBgColor = (headerProps === null || headerProps === void 0 ? void 0 : (ref = headerProps.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color) || "#FFFFFF";
    return {
        storeData: storeData,
        items: items,
        collections: collections,
        user: user,
        navItems: navItems,
        headerBgColor: headerBgColor
    };
};

// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/components/DesignSystem/Drawer/MenuDrawerMobile/index.ts + 1 modules
var MenuDrawerMobile = __webpack_require__(586361);
// EXTERNAL MODULE: ./src/components/MegaMenu/svgIcons.js
var svgIcons = __webpack_require__(120941);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Wishlist/WishlistHeaderMenuItem.tsx
var WishlistHeaderMenuItem = __webpack_require__(155039);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/Header11/index.js

















// import CollectionHeaderDropdown from '../CollectionHeaderDropdown';

















var MegaMenuDesktopView = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6065).then(__webpack_require__.bind(__webpack_require__, 546065)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(546065)
            ];
        }
    },
    ssr: false
});
var Header11 = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useRef)();
    var subNavListRef = (0,react.useRef)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref6 = (0,react.useState)({
        openShop: false,
        openMore: false,
        openDropdown: false
    }), open = ref6[0], setOpen = ref6[1];
    var ref7 = (0,react.useState)({
        desktop: false,
        mobile: false
    }), openMegaMenu = ref7[0], setOpenMegaMenu = ref7[1];
    var ref8 = (0,react.useState)(false), setOpenCollections = ref8[1];
    var ref9 = useHeaderData(props), storeData = ref9.storeData, items = ref9.items, collections = ref9.collections, user = ref9.user, navItems = ref9.navItems;
    var headerThemeColor = !!(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.store_theme_color_status) ? storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color : "#FFFFFF";
    // Give priority to colour set from website builder -> then theme primary color if mx toggles the switch on -> else default white
    var headerBgColor = (props === null || props === void 0 ? void 0 : (ref3 = props.config) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.color_scheme) === null || ref4 === void 0 ? void 0 : ref4.bg_color) || headerThemeColor || "#FFFFFF";
    var headerHeight = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            headerHeight: (ref = state.commonReducer) === null || ref === void 0 ? void 0 : ref.headerHeight
        };
    }).headerHeight;
    var isDesktop = deviceWidth/* deviceWidth */.o > 786;
    var showHeaderIcon = !(isDesktop || checkRenderEnv/* IS_SERVER */.W6);
    var headerRef = (0,react.useRef)();
    // const isShopDropDownEnable = useIsShopDropDownEnable();
    (0,useSaveHeaderHeight/* default */.Z)(headerRef);
    (0,react.useEffect)(function() {
        if (!open.openDropdown) setOpenCollections(false);
    }, [
        open.openDropdown
    ]);
    (0,react.useEffect)(function() {
        // useSSE, ssrTBR To be removed, This will fix the navigation flicker after load
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !(navItems === null || navItems === void 0 ? void 0 : navItems.length)) {
            dispatch((0,additionalPages/* getNavigationPagesList */.A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    var handleClickOutside = function(e) {
        if (isDesktop) {
            if (ref5.current && ref5.current.contains(e.target)) {
                return;
            }
            setOpen(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    openShop: false,
                    openMore: false
                });
            });
        }
    };
    var clickForRoute = function(route) {
        var ref;
        router_default().push((0,routes.getRoute)(route, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var handleCartClick = function() {
        if ((0,getStoreType/* getStoreType */.K)(storeData) === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B) {
            dispatch((0,storeInfo/* toggleRfqFormModal */.H4)());
            return;
        }
        clickForRoute(routes.PATH.CART);
    };
    var menuItemClick = function(nav) {
        if ((openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.desktop) || (openMegaMenu === null || openMegaMenu === void 0 ? void 0 : openMegaMenu.mobile)) {
            setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: false
                };
            });
        }
        if ((nav === null || nav === void 0 ? void 0 : nav.page_type) === "blank_page" && (nav === null || nav === void 0 ? void 0 : nav.is_external_url)) {
            window.open(nav.slug_url, "_blank");
            return;
        }
        if ((nav === null || nav === void 0 ? void 0 : nav.slug_url) === "shop") {
            if (document.querySelector("#CollectionCategoryProductWidget")) {
                document.querySelector("#CollectionCategoryProductWidget").scrollIntoView();
            } else {
                var ref;
                router_default().push((0,routes.getRoute)(routes.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
            }
        } else if ((nav === null || nav === void 0 ? void 0 : nav.slug_url) === "subNavList") {
            setOpen(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    openMore: !open.openMore
                });
            });
        } else {
            if (nav === null || nav === void 0 ? void 0 : nav.is_editable) {
                var ref1;
                router_default().push((0,routes.getRoute)(routes.PATH.additionalPage(nav.slug_url), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
            } else {
                var ref2;
                router_default().push((0,routes.getRoute)(nav.slug_url, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            }
        }
    };
    var toggleDropdown = function() {
        setOpen(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                openDropdown: !state.openDropdown
            });
        });
    };
    var navSubList = function(nav) {
        var ref;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "cfe-dropdown-nav",
            ref: ref5,
            style: {
                top: headerHeight - (((ref = subNavListRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) || 0)
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cfe-dropdown-nav__items",
                children: nav.map(function(n) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "cfe-dropdown-nav__item pv1",
                        onClick: function() {
                            return menuItemClick(n);
                        },
                        children: n.page_name
                    }, n.page_id);
                })
            })
        });
    };
    var closeShopDropdown = (0,react.useCallback)(function() {
        return setOpen(function(state) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                openShop: false,
                openDropdown: false
            });
        });
    }, []);
    var handleShopClick = function(page, dropdownNav) {
        if ((0,showMegaMenu/* showMegaMenu */.G)()) {
            checkClientDeviceType/* IS_DESKTOP */.yn ? setOpenMegaMenu(function() {
                return {
                    mobile: false,
                    desktop: !openMegaMenu.desktop
                };
            }) : setOpenMegaMenu(function() {
                return {
                    desktop: false,
                    mobile: !openMegaMenu.mobile
                };
            });
        } else {
            if (collections === null || collections === void 0 ? void 0 : collections.length) {
                if (dropdownNav) {
                    setOpenCollections(true);
                    setOpen(function(state) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                            openShop: !state.openShop
                        });
                    });
                } else {
                    menuItemClick(page);
                }
            } else {
                !dropdownNav && menuItemClick(page);
                open.openShop ? setOpen(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        openShop: false
                    });
                }) : setOpen(function(state) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        openShop: true,
                        openMore: false
                    });
                });
            }
        }
    };
    var renderNavType = function(page) {
        var dropdownNav = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        switch(page.slug_url){
            case "":
                var ref, ref1;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                showHeaderIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderHome/* HeaderHome */.Q, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonNavbarText/* default */.Z, {
                                    bgColor: headerBgColor,
                                    page: page
                                })
                            ]
                        })
                    })
                }, page.page_id);
            case "shop":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopComponent/* default */.Z, {
                    ref: ref5,
                    page: page,
                    closeShopDropdown: closeShopDropdown,
                    bgColor: headerBgColor,
                    showMegaMenuDesktop: openMegaMenu.desktop,
                    setOpenMegaMenu: setOpenMegaMenu,
                    // open={open}
                    // dropdownNav={isShopDropDownEnable}
                    handleShopClick: handleShopClick
                });
            case "subNavList":
                var ref2;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                    className: "menu-item relative",
                    ref: subNavListRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between",
                            onClick: function() {
                                return menuItemClick(page);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex items-center",
                                    style: {
                                        flex: "1 1 auto"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonNavbarText/* default */.Z, {
                                        bgColor: headerBgColor,
                                        page: {
                                            page_name: "More"
                                        }
                                    })
                                }),
                                (page === null || page === void 0 ? void 0 : (ref2 = page.subNavs) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: " tw-ml-[2px]",
                                    children: open.openMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* AccordionCloseIcon */.x$, {
                                        height: 12.5,
                                        width: 12.5,
                                        secondaryColor: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* AccordionOpenIcon */.Be, {
                                        height: 12.5,
                                        width: 12.5,
                                        secondaryColor: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
                                    })
                                })
                            ]
                        }),
                        open.openMore && navSubList(page.subNavs)
                    ]
                }, page.page_id);
            case "about-us":
                var ref3, ref4;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                showHeaderIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderInfoIcon/* HeaderInfoIcon */.V, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonNavbarText/* default */.Z, {
                                    bgColor: headerBgColor,
                                    page: page
                                })
                            ]
                        })
                    })
                }, page.page_id);
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "menu-item",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonNavbarText/* default */.Z, {
                        bgColor: headerBgColor,
                        page: page
                    })
                }, page.page_id);
        }
    };
    var searchBar = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "search-comp pointer",
            onClick: function() {
                return clickForRoute(routes.PATH.SEARCH);
            },
            style: {
                borderBottom: "0.4px solid ".concat((0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor))
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon/* SearchIcon */.W, {
                    className: "mr3",
                    width: "20",
                    height: "20",
                    color: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "ttu",
                    children: "Search"
                })
            ]
        });
    };
    var leftSection = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "visible-desktop-flex items-center",
                    style: {
                        flex: "1 1 auto"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreNameComponent/* StoreNameComp */._, {
                                showLogo: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: navigationItems()
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "visible-mobile-flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReactHamburger["default"], {
                        open: open.openDropdown,
                        setOpen: toggleDropdown,
                        theme: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
                    })
                })
            ]
        });
    };
    var navigationItems = function() {
        return (navItems === null || navItems === void 0 ? void 0 : navItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "menu-list",
            children: navItems === null || navItems === void 0 ? void 0 : navItems.map(function(nav) {
                return renderNavType(nav, false);
            })
        });
    };
    var rightSection = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                flex: "1"
            },
            children: [
                checkClientDeviceType/* SSR_DESKTOP */.wd && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "flex items-center justify-end icon-set visible-desktop-flex",
                    children: [
                        searchBar(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tw-cursor-pointer tw-pr-3",
                            onClick: function() {
                                return clickForRoute(routes.PATH.WISHLIST);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WishlistHeaderMenuItem/* default */.Z, {
                                color: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "right-section-component flex",
                            style: {
                                paddingRight: 24,
                                width: "108px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginAndDropdownComponent/* default */.Z, {
                                headerBgColor: headerBgColor,
                                children: [
                                    !(user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "header-text",
                                        children: "Login"
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginUserIcon/* LoginUserIcon */.i, {
                                        width: "23",
                                        height: "23",
                                        color: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
                                    }),
                                    (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: "dropdown button",
                                        src: "/assets/images/down-arrow-thin.svg",
                                        className: "ml2 arrow-icon ".concat((0,invertAngleRightIconColor/* invertAngleRightIconColor */.p)(headerBgColor))
                                    }) : ""
                                ]
                            })
                        }),
                        !(props === null || props === void 0 ? void 0 : props.hideCart) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "right-section-component flex",
                            onClick: handleCartClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "header-text",
                                    children: "Cart"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingBag/* ShoppingBag */.C, {
                                    width: "25",
                                    height: "25",
                                    color: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
                                }),
                                (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "cart-items absolute z-2 ".concat((0,invertAngleRightIconColor/* invertAngleRightIconColor */.p)(headerBgColor)),
                                    children: items.length
                                })
                            ]
                        })
                    ]
                }),
                checkClientDeviceType/* SSR_MOBILE */.Ty && /*#__PURE__*/ (0,jsx_runtime.jsx)(CommonHeaderIcons/* CommonHeaderIconsMobile */.r, {
                    className: "visible-mobile-flex",
                    color: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor),
                    headerName: "header11"
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        ref: headerRef,
        className: "header11 collection-header search-comp",
        style: {
            background: headerBgColor,
            color: (0,getContrastingColor/* getContrastingColor */.Q)(headerBgColor)
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header11__component",
                children: [
                    leftSection(),
                    rightSection()
                ]
            }),
            openMegaMenu.desktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenuDesktopView, {
                open: openMegaMenu.desktop,
                onClose: function() {
                    return setOpenMegaMenu({
                        desktop: false,
                        mobile: false
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDrawerMobile/* MenuDrawerMobile */.R, {
                isVisible: open.openDropdown,
                closeDrawer: toggleDropdown
            })
        ]
    });
};
/* harmony default export */ var Headers_Header11 = (Header11);


/***/ }),

/***/ 155039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var _assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(407056);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298627);
/* harmony import */ var src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(482516);





var WishlistIcon = function(param) {
    var color = param.color, iconSize = param.iconSize, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        color: color,
        iconSize: iconSize,
        isActive: isActive
    });
};
var WishlistText = function(param) {
    var _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Wishlist" : _ctaText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "tw-font-inter tw-text-[17px] tw-font-normal ".concat(customTextClassName),
        children: ctaText
    });
};
var WishlistBoth = function(param) {
    var color = param.color, iconPosition = param.iconPosition, iconSize = param.iconSize, wrapperClassName = param.wrapperClassName, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, ctaText = param.ctaText, isActive = param.isActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-flex tw-gap-[10px] tw-items-center ".concat(wrapperClassName),
        children: iconPosition === "right" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
                    color: color,
                    iconSize: iconSize,
                    isActive: isActive
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
                    customTextClassName: customTextClassName,
                    ctaText: ctaText
                })
            ]
        })
    });
};
var WishlistHeaderMenuItem = function(param) {
    var color = param.color, iconSize = param.iconSize, _iconPosition = param.iconPosition, iconPosition = _iconPosition === void 0 ? "right" : _iconPosition, _showComponent = param.showComponent, showComponent = _showComponent === void 0 ? "both" : _showComponent, _customTextClassName = param.customTextClassName, customTextClassName = _customTextClassName === void 0 ? "" : _customTextClassName, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "" : _wrapperClassName, ctaText = param.ctaText, isActive = param.isActive, onClick = param.onClick;
    var wishlistFeatureActive = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return {
            wishlistFeatureActive: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : (ref1 = ref.store) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.services) === null || ref2 === void 0 ? void 0 : ref2.wishlist_flag
        };
    }).wishlistFeatureActive;
    var wishlistFeatureStatus = (0,src_hooks_useFeatureLocks__WEBPACK_IMPORTED_MODULE_4__/* .useFeatureLocks */ .r)().wishlistFeatureStatus;
    if (wishlistFeatureActive !== _constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE */ .g.WISHLIST_ACTIVE || (wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked)) {
        return null;
    }
    if (showComponent === "icon") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistIcon, {
            color: color,
            iconSize: iconSize,
            isActive: isActive
        })
    });
    if (showComponent === "text") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        className: "tw-flex tw-items-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistText, {
            customTextClassName: customTextClassName,
            ctaText: ctaText
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: onClick,
        style: {
            cursor: onClick ? "pointer" : undefined
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WishlistBoth, {
            color: color,
            iconPosition: iconPosition,
            iconSize: iconSize,
            wrapperClassName: wrapperClassName,
            customTextClassName: customTextClassName,
            ctaText: ctaText,
            isActive: isActive
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WishlistHeaderMenuItem);


/***/ }),

/***/ 636874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ invertAngleRightIconColor; }
/* harmony export */ });
/* harmony import */ var _getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(956494);

/**
 * invert classes are applied on angle icon based on the headerBgColor
 * @param {*} headerBgColor
 * @return {String} a class based on headerBgColor
 */ function invertAngleRightIconColor(headerBgColor) {
    return (0,_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_0__/* .getCustomHeaderTextColor */ .s)(headerBgColor) === "#ffffff" ? "filter-invert-1" : "filter-invert-0";
}


/***/ })

}]);